import {Injectable} from '@angular/core';
import {SubscriptionsService} from './subscriptions.service';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {LoginService} from '../shared/navigation/login.service';
import {Subscription} from 'rxjs';
import {CurrencyService} from './currency.service';
import {isNumeric} from 'rxjs/util/isNumeric';

@Injectable()
export class CartService {
    userData: any;
    cart: any;
    error74: boolean;
    errorDefault: boolean;
    subtotal: any;
    discount: any;
    payable: any;
    paymentResult: any;
    changedCurrency: Subscription;
    currency: any;
    purchaseAnyway: string;
    minusBalanceValue: number;
    priceRecalculated: boolean;

    constructor(private subscriptionsService: SubscriptionsService,
                public lotteryService: LotteriesService,
                private loginService: LoginService,
                public currencyService: CurrencyService) {
        this.currency = this.currencyService.currency;
        this.changedCurrency = this.subscriptionsService.getChangeCurrency().subscribe(currency => {
            if (currency) {
                this.currency = currency;
            }
        });
        this.priceRecalculated = false;
    }

    public updateCartLength(): void {
        let cart = localStorage.getItem('cart');
        if (cart !== undefined && cart !== null) {
            cart = JSON.parse(cart);
        }
        if (cart !== null && cart.length > 0) {
            this.subscriptionsService.updateCart(cart.length);
            this.subscriptionsService.updateCartItems(cart);
        }
        if (cart === null) {
            this.subscriptionsService.updateCart(0);
        }
        this.subscriptionsService.emitSendPayment('refreshButton');
    }

    public addToCartAfterLogin(SessionID, userData, cart, error74, errorDefault) {
        const sendDataCart = {};
        sendDataCart['sessionId'] = SessionID;
        this.userData = userData;
        this.cart = cart;
        this.error74 = error74;
        this.errorDefault = errorDefault;

        this.lotteryService
            .postData
            (globals.appDomain + '/cart/get/'
                + this.userData.memberId + '/cartGet_nav_serviceXX.json', this.loginService.getFormUrlEncoded(sendDataCart))
            .subscribe(
                response => {
                    if (response.message.Packages) {
                        localStorage.setItem('tempCart', JSON.stringify(response.message.Packages));
                    }
                    const tempCart = localStorage.getItem('tempCart');
                    const cartX = localStorage.getItem('cart');
                    if (cartX) {
                        const localCart = JSON.parse(cartX);
                        if (tempCart !== null) {
                            this.cart = JSON.parse(tempCart).concat(localCart);
                        } else {
                            this.cart = localCart;
                        }
                        let cartToSend = '';
                        const playerShares = localStorage.getItem('playerShares') === '1' ? '&playerShares=' + 1 : '';

                        cartToSend += '&sessionId=' + this.userData.sessionId;
                        cartToSend += '&sessionCart=1' + playerShares;
                        for (const x of Object.keys(this.cart)) {
                            cartToSend += '&packageId[' + x + ']=' + this.cart[x].PackageID;
                            cartToSend += '&lotteryId[' + x + ']=' + this.cart[x].Items[0].LotteryID;
                            cartToSend += '&billingPeriod[' + x + ']=1';
                            cartToSend += '&isSubscription[' + x + ']=0';
                            cartToSend += '&drawCount[' + x + ']=' + this.cart[x].DrawCount;
                            if (this.cart[x].Items[0].PlayerShares) {
                                cartToSend += '&playerShares[' + x + ']=' + this.cart[x].Items[0].PlayerShares;
                            }
                            if (this.cart[x].TicketsCount) {
                                cartToSend += '&TicketsCount[' + x + ']=' + this.cart[x].TicketsCount;
                            }
                            for (const i of Object.keys(this.cart[x].Items)) {
                                if (this.cart[x].Items[i].PickedNumbers) {
                                    for (const z of Object.keys(this.cart[x].Items[i].PickedNumbers)) {
                                        cartToSend
                                            += '&base[' + x + '][]='
                                            + JSON.stringify(this.cart[x].Items[i].PickedNumbers[z].BasePick);
                                        cartToSend
                                            += '&extra[' + x + '][]='
                                            + JSON.stringify(this.cart[x].Items[i].PickedNumbers[z].ExtraPick);
                                    }
                                }
                            }
                        }
                        cartToSend += '&currency=' + this.currency;
                        this.lotteryService
                            .postData(globals.appDomain + '/cart/addSingleTicket/' +
                                this.userData.memberId + '/cartAddSingleTicket_nav.json', cartToSend)
                            .subscribe(
                                resp => {
                                    if (resp.addCartMessage.ErrorID === undefined) {
                                        localStorage.setItem
                                        ('cart', JSON.stringify(resp.addCartMessage.Cart.Packages));
                                        this.updateCartLength();
                                    }
                                    if (resp.addCartMessage.ErrorID !== undefined && resp.addCartMessage.ErrorID === '074') {
                                        this.error74 = true;
                                        setTimeout(() => {
                                            this.error74 = false;
                                        }, 15000);
                                    } else if (resp.addCartMessage.ErrorID !== undefined) {
                                        this.errorDefault = true;
                                        setTimeout(() => {
                                            this.errorDefault = false;
                                        }, 15000);
                                        this.updateCartLength();
                                    }
                                }
                            );
                    } else {
                        if (tempCart !== null) {
                            localStorage.setItem('cart', tempCart);
                            this.updateCartLength();
                        }
                        localStorage.removeItem('tempCart');
                    }
                    this.subscriptionsService.emitSendPayment('refreshButton');
                }
            );

        return {SessionID: SessionID, userData: this.userData, cart: this.cart, error74: this.error74, errorDefault: this.errorDefault};
    }

    public mapPrice(response, discount) {
        this.priceRecalculated = false;
        const user = localStorage.getItem('playerDetails');
        let userObj;
        if (user) {
            const sendData = {};
            userObj = JSON.parse(user);
            sendData['Fields'] = 'RealBalance,BonusBalance';
            sendData['sessionId'] = userObj.sessionId;
            this.loginService
                .postData
                (globals.appDomain + '/user/details/' + userObj.MemberID +
                    '/userDetails_cartService.json', this.loginService.getFormUrlEncoded(sendData))
                .subscribe(
                    data => {
                        if (data && data.message) {
                            this.subtotal = 0.00;
                            this.discount = 0.00;
                            this.payable = 0.00;
                            this.priceRecalculated = true;
                            userObj = data.message;
                            const cart = localStorage.getItem('cart');
                            if (cart) {
                                if (!user && !discount) {
                                    const jsonCart = JSON.parse(cart);
                                    jsonCart.forEach(el => {
                                        this.subtotal += +el.OriginPrice;
                                        this.payable += +el.PackagePrice;
                                    });
                                    this.discount = (this.subtotal - this.payable);
                                    this.subscriptionsService.emitSendPayment('refreshButton');
                                    return this.subtotal.toFixed(2), this.discount.toFixed(2), this.payable.toFixed(2);
                                } else if (response && response !== 'error') {
                                    this.subtotal += +response.OriginPrice;
                                    this.payable += +response.Price;
                                    this.discount = (this.subtotal - this.payable);
                                    if (+userObj.RealBalance > 0) {
                                        if (+userObj.RealBalance > this.payable) {
                                            this.minusBalanceValue = this.payable;
                                            this.payable = 0.00;
                                        } else {
                                            this.minusBalanceValue = +userObj.RealBalance;
                                            this.payable = this.payable - +userObj.RealBalance;
                                        }
                                    }
                                    this.subscriptionsService.emitSendPayment('refreshButton');
                                    return this.subtotal.toFixed(2), this.discount.toFixed(2), this.payable.toFixed(2);
                                }
                            } else {
                                this.subtotal += 0.00;
                                this.payable += 0.00;
                                this.discount = (this.subtotal - this.payable);
                                this.subscriptionsService.emitSendPayment('refreshButton');
                                return this.subtotal.toFixed(2), this.discount.toFixed(2), this.payable.toFixed(2);
                            }
                        }
                    }
                );
        } else {
            this.subtotal = 0.00;
            this.discount = 0.00;
            this.payable = 0.00;
            if (response) {
                response.Packages.forEach(el => {
                    this.subtotal += +el.OriginPrice;
                    this.payable += +el.PackagePrice;
                    this.discount = (this.subtotal - this.payable);
                });
            }
            this.priceRecalculated = true;
        }
        this.subscriptionsService.emitSendPayment('refreshButton');
    }

    cleanBox() {
        this.subtotal = 0.00;
        this.discount = 0.00;
        this.payable = 0.00;
        this.minusBalanceValue = 0.00;
        this.subscriptionsService.emitSendPayment('refreshButton');
    }

    sendPayment(url, body) {
        this.purchaseAnyway = 'false';
        return new Promise(resolve => {
            this.lotteryService.postData(
                url, body)
                .subscribe(
                    result => {
                        this.paymentResult = result;
                        resolve('resolved');
                        this.subscriptionsService.emitSendPayment('refreshButton');
                    });
        });
    }

    calculateCartFromLocal() {
        const cartStr = localStorage.getItem('cart');
        this.subtotal = 0;
        if (cartStr) {
            const cart = JSON.parse(cartStr);
            cart.forEach((val, ind) => {
                this.subtotal += +val.PackagePrice;
            });
        }
        this.subscriptionsService.emitSendPayment('refreshButton');
    }
}
